import {
    makeActionCreator,
    PROFILE_ADD,
    PROFILE_SUCCESS,
    PROFILE_FAILURE
} from '../actionTypes'

export const profileAdd = makeActionCreator(PROFILE_ADD,'name','level','school','userType')
export const profileSuccess = makeActionCreator(PROFILE_SUCCESS)
export const profileFailure = makeActionCreator(PROFILE_FAILURE)


// WEBPACK FOOTER //
// ./src/profile/action.js